import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

interface IProps{
  onCountChange: (newCount: number) => void;
}

export const CounterButton: React.FC<IProps>= ({onCountChange}) => {
  const [count, setCount] = useState(0);

  const increment = () => {
    const newCount = count + 1;
    setCount(newCount);
    onCountChange(newCount);
  };

  const decrement = () => {
    const newCount = count > 0 ? count - 1 : 0;
    setCount(newCount);
    onCountChange(newCount);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
      <Button
        variant="outlined"
        color="primary"
        onClick={decrement}
        style={{ borderRadius: '50px'}}
      >
        <RemoveIcon />
      </Button>
      <Typography variant="h6" style={{ margin: '0 10px' }}>
        {count}
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        onClick={increment}
        style={{ borderRadius: '50px'}}
      >
        <AddIcon />
      </Button>
    </div>
  );
};